<!--

== Base Empty

Props:

    > image
    Caminho da imagem, caso a prop não seja passada será setada uma imagem padrão.

    > title
    Título.

    > message
    Texto de descrição.

    > buttonText
    Texto do botão, caso não seja passada a prop o botão não será exibido.

-->

<template>
  <div class="empty-container">
    <img :src="this.image" alt="Imagem" />
    <h1>{{ this.title }}</h1>
    <p>{{ this.message }}</p>
    <button v-if="buttonText" @click="execute">{{ this.buttonText }}</button>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: [String],
      default: 'https://cdn.easydelivery.com.br/Dominio.svg',
    },
    title: String,
    message: String,
    buttonText: { type: String },
  },
  methods: {
    execute() {
      this.$emit('onClick');
    },
  },
};
</script>

<style scoped>
.empty-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 200;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--background-up);
  padding: 0 15px;
}

.empty-container img {
  width: 160px;
  max-width: 100%;
}

.empty-container h1 {
  font-size: 20px;
  color: #999;
  font-family: 'Rubik-Regular', sans-serif;
  margin: 20px 0;
  text-align: center;
}

.empty-container p {
  font-size: 18px;
  color: #999;
  opacity: 0.6;
  font-family: 'Lato-Regular', sans-serif;
  text-align: center;
}

.empty-container button {
  border: none;
  font-size: 12px;
  font-family: 'Lato', sans-serif;
  font-weight: bold;
  cursor: pointer;
  color: #fff;
  background: var(--default);
  border-radius: 5px;
  min-height: 45px;
  padding: 15px 45px;
  text-transform: uppercase;
  margin-top: 35px;
}

.empty-container button:focus,
.empty-container button:active {
  outline: none;
}
</style>
